'use strict';

import React from 'react';
import get from 'lodash/get';
import Notification from '../../Notification';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { formatDate, formatTime, getTime } from '../../../utils/TimeUtils';
import { getDepartmentDisplay } from '../../../utils/TimelineUtils';
import Loader from '../../Loader';
import OTIcon from '../../tag/OTIcon';
import OTButton from '../../tag/OTButton';
import { doRequestDismissNotifications } from '../../../data/notification/actions';
import { QUESTIONNAIRE_PAGE_NOTIFICATION } from '../../../definitions/NotificationConstants';
import OTButtonGroup from '../../tag/OTButtonGroup';
import Row from '../../tag/Row';
import Span from '../../tag/Span';
import { showOmavointiQuestionnaireModal } from '../../../data/questionnaires/actions';
import { QUESTIONNAIRES } from '../../../data/reducer';
import MobileClientModal from '../MobileClientModal';
import { LONG_DESCRIPTON_FORM_CODE } from '../../../definitions/QuestionnaireConstants';

const { id: module_id } = module;

class CareRequestNotification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMobileClientModal: false,
    };
  }

  toggleModalState = () => {
    this.setState({ showMobileClientModal: !this.state.showMobileClientModal });
  };

  fillClicked = () => {
    let { data, showOmavointiQuestionnaireModal, mobileClientState } =
      this.props;

    !mobileClientState
      ? showOmavointiQuestionnaireModal(data.formCode, data.link)
      : this.toggleModalState();
  };

  /*
    If the questionnaire is 15d, show the description given in the data.
    Else show generic description
   */
  renderLongDescription() {
    let { data } = this.props;
    return data.formCode === LONG_DESCRIPTON_FORM_CODE ? (
      data.longDescription && (
        <div className="ot-notification__description">
          {data.longDescription}
        </div>
      )
    ) : (
      <div className="ot-notification__description">
        <FormattedMessage id={`${module_id}.generic.info`} />
      </div>
    );
  }

  render() {
    let {
      data,
      showActiveQuestionnaireDescription,
      doRequestDismissNotifications,
    } = this.props;

    let { appointmentData } = data;

    let endDateTime = get(data, 'endDateTime', null) ? (
      <FormattedMessage
        id={`${module_id}.fill.at.the.latest`}
        values={{
          date: getTime(data.endDateTime).format('DD.MM.YYYY'),
        }}
      />
    ) : null;

    let description = null;

    if (!showActiveQuestionnaireDescription) {
      description = <Loader style={{ margin: '40px auto' }} />;
    } else {
      if (appointmentData) {
        description = (
          <FormattedMessage
            id={`${module_id}.fill.questionnaire.with.appointment`}
            values={{
              name: data.name,
              department: getDepartmentDisplay(appointmentData.department),
              date: formatDate(appointmentData.date),
              time: formatTime(appointmentData.date),
              strong: (chunks) => <strong>{chunks}</strong>,
              strongSemibold: (chunks) => (
                <strong className="semibold">{chunks}</strong>
              ),
            }}
          />
        );
      } else {
        description = (
          <FormattedMessage
            id={`${module_id}.fill.questionnaire`}
            values={{ name: data.name }}
          />
        );
      }
    }

    return (
      <Notification>
        <OTIcon
          config={{ type: 'custom', name: 'kyselyt', color: 'darkblue' }}
          style={{ width: '17px', marginRight: '20px' }}
        />
        <h2 className="ot-notification__header">
          <FormattedMessage id={`${module_id}.new.questionnaire`} />
        </h2>
        {<div className="ot-notification__description">{description}</div>}
        {this.renderLongDescription()}
        {data.description && (
          <div className="ot-notification__description">
            <OTIcon
              config={{ type: 'custom', name: 'palaute', color: 'darkblue' }}
              style={{ marginRight: '5px', height: '15px' }}
            />
            {data.description}
          </div>
        )}
        <div className="ot-notification__description">
          {endDateTime}
          <br />
          <FormattedMessage id={`${module_id}.info.questionnaire`} />
        </div>
        <Row>
          <div className="ot-notification__buttonrow">
            <OTButtonGroup
              collapseOnMobile
              expecedCount={2}
              fullWidth
              type="big"
            >
              <OTButton
                className="ot-notification__button"
                onClick={this.fillClicked}
              >
                <FormattedMessage id={`navigate.to.answer`} />
              </OTButton>
              <OTButton
                onClick={() =>
                  doRequestDismissNotifications(
                    `${QUESTIONNAIRE_PAGE_NOTIFICATION}_${data.id}`
                  )
                }
              >
                <FormattedMessage id={`${module_id}.fill.later`} />
              </OTButton>
            </OTButtonGroup>
          </div>
        </Row>
        {this.state.showMobileClientModal && (
          <MobileClientModal
            isOpen={this.state.showMobileClientModal}
            hideModal={() => this.toggleModalState()}
          />
        )}
      </Notification>
    );
  }
}

const mapStateToProps = (state) => {
  let mobileClientState = state[QUESTIONNAIRES].mobileClientState;
  return {
    mobileClientState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doRequestDismissNotifications: (notificationId) =>
      dispatch(doRequestDismissNotifications([notificationId])),
    showOmavointiQuestionnaireModal: (...props) =>
      dispatch(showOmavointiQuestionnaireModal(...props)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CareRequestNotification);
